import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7fd0929a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tactic-info" }
const _hoisted_2 = { class: "info-title" }
const _hoisted_3 = { class: "info-value" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "info-title"
}
const _hoisted_7 = {
  key: 1,
  class: "info-title"
}
const _hoisted_8 = {
  key: 2,
  class: "info-value"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 3,
  class: "info-value"
}
const _hoisted_12 = { class: "operation-info" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Cost", -1))

import { ref } from "vue";
import BaseDialog from "../base/dialogs/BaseDialog.vue";
import { DateObject, Tactic, TacticOperation } from "@/classes";
import NumberField from "../base/inputs/NumberField.vue";
import Decimal from "decimal.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'TacticDialog',
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;

const dialog = ref(false);
const tactic = ref<Tactic>(new Tactic());
const loading = ref(false);

const open = async (id: string | null) => {
  dialog.value = true;
  if (id) {
    tactic.value = await Tactic.get(id);
  } else {
    tactic.value = new Tactic();
  }
};

const fields: {
  title: string;
  key: keyof Tactic;
  format?: (val: any) => string;
}[] = [
  { title: "Maintenance Item", key: "maintenance_item" },
  { title: "Maintenance Item Desc.", key: "maintenance_item_description" },
  { title: "Maintenance Plan", key: "maintenance_plan" },
  { title: "Maintenance Plan Desc.", key: "maintenance_plan_description" },
  { title: "Strategy", key: "strategy" },
  { title: "Functional Location", key: "functional_location" },
  { title: "Func. Loc. Desc.", key: "functional_location_description" },
  { title: "Asset Criticality", key: "asset_criticality" },
  { title: "Planning Plant", key: "maintenance_item_planning_plant" },
  { title: "Planner Group", key: "maintenance_item_planner_group" },
  { title: "Main Work Center", key: "maintenance_item_main_work_center" },
  {
    title: "Main Work Center Desc.",
    key: "maintenance_item_main_work_center_description",
  },
  { title: "Activity Type", key: "activity_type" },
  { title: "Activity Type Desc.", key: "activity_type_description" },
  { title: "Task List", key: "task_list" },
  { title: "Task List Header Dec.", key: "task_list_header_description" },
];

const tacticOperationFields: {
  title: string;
  key: keyof TacticOperation;
  format?: (val: any) => string;
}[] = [
  { title: "Operation Number", key: "operation_number" },
  { title: "Maintenance Package", key: "maintenance_package" },
  { title: "Operation Text", key: "operation_text" },
  { title: "Operation Work Center", key: "operation_work_center" },
  { title: "Operation Planning Plant", key: "operation_planning_plant" },
];

const save = async () => {
  loading.value = true;
  await tactic.value.save();
  loading.value = false;
  dialog.value = false;
  emits("change");
};

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(BaseDialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    maxWidth: "1000",
    title: "Tactic"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        loading: loading.value,
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("Save")
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.filter((_, i) => i % 2 === 0), (_, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", _hoisted_2, _toDisplayString(fields[i * 2].title), 1),
              _createElementVNode("td", _hoisted_3, [
                (fields[i * 2].format)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(fields[i * 2].format(tactic.value[fields[i * 2].key])), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(tactic.value[fields[i * 2].key]), 1))
              ]),
              (i * 2 + 1 < fields.length)
                ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(fields[i * 2 + 1].title), 1))
                : (_openBlock(), _createElementBlock("td", _hoisted_7)),
              (i * 2 + 1 < fields.length)
                ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                    (fields[i * 2 + 1].format)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(fields[i * 2 + 1].format(tactic.value[fields[i * 2 + 1].key])), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(tactic.value[fields[i * 2 + 1].key]), 1))
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_11))
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode("Operations")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tacticOperationFields, (field) => {
              return _createElementVNode("th", {
                key: field.key
              }, _toDisplayString(field.title), 1)
            }), 64)),
            _hoisted_13
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tactic.value.tactic_operations, (tacticOperation) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: tacticOperation.id
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tacticOperationFields, (field) => {
                return _createElementVNode("td", {
                  key: field.key
                }, _toDisplayString(tacticOperation[field.key]), 1)
              }), 64)),
              _createElementVNode("td", null, [
                _createVNode(NumberField, {
                  class: "width-120",
                  "model-value": tacticOperation.cost.toNumber(),
                  "text-align": "left",
                  label: "Cost",
                  prefix: "$",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  required: "",
                  "onUpdate:modelValue": ($event: any) => (tacticOperation.cost = new (_unref(Decimal))($event))
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})